import { Component } from '@angular/core';
import { AccessorySecondPageModel } from '../../models/accessory-second-page.model';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { combineLatest } from 'rxjs';
import { CommonInfoService } from '../../cart-process/common-info.service';

@Component({
  selector: 'side-order-details-accessory',
  templateUrl: './side-order-details-accessory.component.html',
})
export class SideOrderDetailsAccessoryComponent {
  public showSection = false;
  public accessorySlot: Array<AccessorySecondPageModel> = [];
  public showSectionHeader = false;
  public currencySymbol = 'zł';

  constructor(
    public commonInfo: CommonInfoService,
    private notificationProvider: NotificationProviderService
  ) {

    combineLatest(
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.SLOTS_SERVICE),
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.COMMON_INFO)
    ).subscribe( (context: any) => {

      const [slotService, commonInfo]: any = context;

      if (!slotService || !commonInfo) {
        return;
      }

      const list: any = slotService.accessories;
      this.showSection = !!list.length;
      this.showSectionHeader = this.showSection && !commonInfo.isOtherSalesOffer;
      this.accessorySlot = list;
    });
  }

}
